import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { LoggerService } from '@app/core/logger/logger.service';
import { NavigationService } from '@app/core/navigation/navigation.service';
import { firstValueFrom } from 'rxjs';
import { RsvpService } from './rsvp.service';
import { CRouteList } from '@app/route-list.const';

export const RsvpCanActivateFn: CanActivateFn = async (route) => {
  const uniqueBookingId = route.params.id;
  const navigationService = inject(NavigationService);
  const loggerService = inject(LoggerService);
  try {
    const rsvpService = inject(RsvpService);
    const rsvpVenueInfo = await firstValueFrom(rsvpService.loadRsvpVenueInfo(uniqueBookingId));
    rsvpService.setRsvpVenueInfoSync(rsvpVenueInfo);
    rsvpService.setUniqueBookingIdSync(uniqueBookingId);
    return true;
  } catch (error) {
    navigationService.navigateToUrl(CRouteList.error);
    loggerService.warn(`Error loading RSVP venue info: ${error}`);
    return false;
  }
};
